import { render, staticRenderFns } from "./ReviewFlows.vue?vue&type=template&id=67b7f664&"
import script from "./ReviewFlows.vue?vue&type=script&lang=js&"
export * from "./ReviewFlows.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports